import * as api from "@tytapp/api";
import { Playable } from "@tytapp/media-playback";

export class VOD extends api.ApiVOD implements Playable {

}